// const baseSize = 16

// function setRem() {
// 	const scale = document.documentElement.clientWidth / 1920;
// 	if (document.documentElement.clientWidth > 910) {
// 		document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
// 	}
// }
// setRem()
// window.onresize = function() {
// 	setRem()
// }

/**
 * rem自适应方案
 * @param baseWidth 设计稿基准宽度 1920
 * @param baseFont 基准fontSize，100
 */
export function initRem(baseWidth = 1920, baseFont = 100) {
  const setHtmlFontSize = () => {
    // 获取视口宽度
    const screenWidth = document.documentElement.clientWidth || window.innerWidth;
    const maxWidth = baseWidth;    // 上限：1920，超过不再放大
    const minWidth = 1200;         // 下限：1200，小于不再缩小（关键新增）

    let width = screenWidth;
    width = Math.max(width, minWidth);   // 不能低于最小值
    width = Math.min(width, maxWidth);   // 不能高于最大值

    const fontSize = (width / baseWidth) * baseFont;
    document.documentElement.style.fontSize = `${fontSize}px`;
  };

  // 初始化执行
  setHtmlFontSize();
  // 窗口大小改变重新计算
  window.addEventListener('resize', setHtmlFontSize);
  window.addEventListener('orientationchange', setHtmlFontSize);
}